<template>
  <div id="State">
      <v-container class="pa-0">
        <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn v-if="editIndex === -1" fab absolute right class="mr-3 pf-btn-fab" :href="'#/states/add'">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-else fab absolute left @click="backTolisting" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </v-container>  
      <v-container grid-list-md fluid class="pt-0" v-if="editIndex === -1">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card class="mt-1">
      <v-data-table
        :headers="stateHeaders"
        :items="State"
        :search="search"
        class="pf-data-table"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.country.name }}</td>
          <td align="right">
            <v-btn icon class="ma-0" @click="editItem(props.item)">
              <v-icon size="22" color="grey darken-2">edit</v-icon>
            </v-btn>
            <v-btn icon class="ma-0" @click="deleteItem(props.item)">
              <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      </v-card>
      </v-container>
      <v-form v-else ref="formEdit">
        <v-container>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field label="State" v-model.trim="editData.name" :rules="formRules.state" class="required pr-4 pl-4" @input="changedData"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
               <v-flex class="xs12 sm6 full">
                <v-autocomplete
                    label="Country" 
                    :items="Country"
                    item-text="name"
                    item-value="id"
                    height="30px"
                    v-model="editData.country"
                    class="required pr-4 pl-4"
                    :rules="formRules.country"
                    @change="changedData"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>      
  </div>
</template>

<script>
/* global session store config */
import swal from 'sweetalert2';
import { getCollection, update, remove } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
export default {
  data: () => ({
    entity: 'State',
    editIndex: -1,
    editData: {},
    selectedData: false,
    search: '',
    stateHeaders: [
      { text: 'State', value: 'name', align: 'left', width: '40%' },
      { text: 'Country', value: 'country.name' },
      { text: '', sortable: false },
    ],
    formRules: {
      state: [v => !!v.trim() || 'State is required'],
      country: [v => !!v || 'Country is required']
    },
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },    
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['State']),
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    }
  },
  created () {
    this.initialize('State');
    this.feedSelects('Country');
  },
  methods: {
    async feedSelects (entity) {
      if (!this[entity].length) {
        let { error, data, status } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          this[entity] = data;
        }
      }
    },    
    async initialize () {
      if (!this.State.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          store.commit('setState', data);
        }
      }
    },
    editItem (item) {
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.editIndex = this.State.indexOf(item);
      this.editData = Object.assign({}, item);
    },
    changedData () {
      this.selectedData = true;
    },
    async save () {
      if (this.$refs.formEdit.validate() && this.editIndex > -1) {
        this.selectedData = false;
        let { error, data, status } = await update('State', this.editData, this.editData.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.State[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'State updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    backTolisting () {
      this.editIndex = -1;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    },        
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.State.indexOf(item);
              this.State.splice(index, 1);
              swal.fire(
                'Deleted!',
                'The State "' + item.name + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/States/list.vue